import React, { useEffect } from "react";
import { gsap } from "gsap";
import "../Contact/Poc.css";

const Poc = () => {
  useEffect(() => {
    // GSAP Animation
    const image = document.querySelector(".entry-image-epc");
    const overlay = document.querySelector(".entry-overlay-epc");
    const text = document.querySelector(".entry-text-epc");
    const verticalStrips = document.querySelectorAll(".vertical-strip-epc");

    gsap.fromTo(
      ".vertical-strip-epc",
      {
        scaleX: 0,
        opacity: 0,
        x: "-100%",
      },
      {
        duration: 2,
        scaleX: 1,
        opacity: 1,
        x: "0%",
        stagger: 0.05,
        ease: "power3.out",
        onComplete: () => {
          // Fade in the overlay text and main text
          gsap.to(overlay, { opacity: 1, duration: 1 });
          gsap.to(text, { opacity: 1, duration: 1 });

          // Fade out the strips after animation
          gsap.to(verticalStrips, { opacity: 0, duration: 1, stagger: 0.05 });
        },
      },
    );
  }, []);

  return (
    <div className="entry-container-epc">
      <div className="entry-image-container-epc">
        <img src="/contact.webp" alt="Entry" className="entry-image-epc" />
        <div className="entry-overlay-epc">
          <h1 className="entry-overlay-text-epc">Contact Us</h1>
          <p className="entry-text-epc">
            We aim to lead in each practice and area of law we work in. Feel
            free to connect us.
          </p>
        </div>
      </div>
      <div className="strips-epc">
        {[...Array(25)].map((_, index) => (
          <div key={index} className="vertical-strip-epc"></div>
        ))}
      </div>
    </div>
  );
};

export default Poc;
